import { memo } from 'react';

import OptionButton from '@/components/common/OptionButton/OptionButton';
import CheckTick from '@/components/common/OptionButton/icons/CheckIcon/CheckTick';


interface IExportContainer {
  onExcelExport: () => void;
}

function ExportToExcelContainer({ onExcelExport }: IExportContainer) {

  return (
    <OptionButton
      onClick={onExcelExport}
      Icon={<CheckTick />}
    >
      Export to Excel
    </OptionButton>
  );
}

export default memo(ExportToExcelContainer);
